import {useCallback, useEffect, useState} from "react";
import {getAgencies} from "../../service/UserService";

const LOAD_ERROR_MESSAGE = "Unable to load Agency Block status. Assignments remain enabled.";

export default function useBlockedAgencyStatus() {
    const [blockedAgencyIds, setBlockedAgencyIds] = useState(() => new Set());
    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");

    const refresh = useCallback(async () => {
        setIsLoading(true);
        setErrorMessage("");

        try {
            const response = await getAgencies();
            if (response.status !== 200) {
                console.log(await response.text());
                setBlockedAgencyIds(new Set());
                setErrorMessage(LOAD_ERROR_MESSAGE);
                return;
            }

            const agencies = await response.json();
            setBlockedAgencyIds(new Set(
                agencies
                    .filter((agency) => agency.blocked === true && agency.cos_customer_id != null)
                    .map((agency) => String(agency.cos_customer_id)),
            ));
        } catch (error) {
            console.log("error", error);
            setBlockedAgencyIds(new Set());
            setErrorMessage(LOAD_ERROR_MESSAGE);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    return {
        blockedAgencyIds,
        errorMessage,
        isLoading,
        refresh,
    };
}
